import { POST } from "./utils";

export const joinWaitlist = async (email: string) => {
    return await POST("/api/waitlist/join", { email });
};

export const registerUseCase = async (email: string, useCase: string) => {
    return await POST("/api/waitlist/use-case", { email, useCase });
};

export const registerNeedSomethingElse = async (text: string, email?: string) => {
    const payload: { text: string; email?: string } = { text };

    if (email) {
        payload.email = email;
    }

    return await POST("/api/waitlist/other", payload);
};
